import ModelFactory from 'business/models/ModelFactory';
import {
  SearchClient,
  SearchResultsDTO,
  SearchDetailDTO,
  SearchItemsTarget,
} from 'business/models/Models';
import BaseService from './BaseService';

export default class SearchService extends BaseService {
  async Search(
    searchQuery: string,
    searchTarget: SearchItemsTarget[],
  ): Promise<SearchResultsDTO[]> {
    const searchClient: SearchClient = ModelFactory(SearchClient, false, true);
    const searchDetails = new SearchDetailDTO();
    searchDetails.searchQuery = searchQuery;
    searchDetails.searchTarget = searchTarget;

    return await searchClient.search(searchDetails);
  }
}
